import { useIntl } from 'react-intl'
import { Grid } from '@material-ui/core'
import * as moment from 'moment'
import React, { useState, useReducer, useEffect } from 'react'
import voucherStartEndTimeReducer, {
  INIT_STATE,
  TYPE_UPDATE_PARTIAL,
  startDateTimeKey,
  endDateTimeKey,
} from './VoucherStartEndTimeReducer'

import { DatePicker } from '@material-ui/pickers'
import {
  DISPLAY_FORMAT_DATE_US,
  API_DATE_FORMATTED,
  isPastStartDateVoucher,
  isPastEndDateVoucher,
} from 'libs/dateUtils'
import { getDatePickerDisplayFormat } from 'commons/date'
import LocalizedDatePickerToolbar from 'app/components/datepickers/LocalizedDatePickerToolbar'
import LocalizedDatePickerProvider from 'app/components/datepickers/LocalizedDatePickerProvider'

const VoucherStartEndTime = (props) => {
  const {
    onChange,
    value,
    isEditMode = false,
    initialModel,
    isAttached = false,
    isStatusInActive = false,
  } = props
  const { formatMessage } = useIntl()
  const [state, dispatch] = useReducer(
    voucherStartEndTimeReducer,
    value || INIT_STATE,
  )

  const minStartDate = moment().startOf('day')

  const [minDate, setMinDate] = useState(minStartDate)
  const maxDate = moment().add(10, 'years')

  useEffect(() => {
    if (isEditMode) {
      if (minStartDate.isAfter(state[startDateTimeKey])) {
        setMinDate(state[startDateTimeKey])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, state])

  useEffect(() => {
    onChange(state)
  }, [onChange, state])

  const onVoucherStartDateTimeChange = (value) => {
    let startDate = moment(value).startOf('day')
    let endDate = moment(value).endOf('day')

    if (moment(value).isBefore(moment(state[endDateTimeKey]))) {
      endDate = moment(state[endDateTimeKey]).endOf('day')
    }

    if (isEditMode && moment(value).isBefore(moment().startOf('day'))) {
      startDate = moment().startOf('day')
      endDate = moment().endOf('day')
    }

    dispatch({
      type: TYPE_UPDATE_PARTIAL,
      key: startDateTimeKey,
      value: startDate,
    })

    dispatch({
      type: TYPE_UPDATE_PARTIAL,
      key: endDateTimeKey,
      value: endDate,
    })
  }

  const getValidMinEndDate = () => {
    if (state && state[startDateTimeKey]) {
      return {
        minDate: isPastStartDateVoucher(state[startDateTimeKey])
          ? moment()
          : moment(state[startDateTimeKey], API_DATE_FORMATTED),
      }
    }

    return {}
  }

  const onEventEndDateTimeChange = (value) => {
    let endDate = moment(value).endOf('day')

    if (isEditMode && moment(value).isBefore(moment())) {
      endDate = moment().endOf('day')
    }

    dispatch({
      type: TYPE_UPDATE_PARTIAL,
      key: endDateTimeKey,
      value: endDate,
    })
  }

  return (
    <>
      <LocalizedDatePickerProvider>
        <Grid container className="flex items-center" spacing={1}>
          <Grid item xs={12} md={6} className="mb-10">
            <DatePicker
              className="w-full"
              required
              inputProps={{
                'data-testid': 'startDate',
              }}
              label={formatMessage({
                id: 'createNotification.dialog.voucher.startDate',
              })}
              minDate={minDate}
              maxDate={maxDate}
              inputVariant="outlined"
              value={
                state[startDateTimeKey]
                  ? moment(state[startDateTimeKey], API_DATE_FORMATTED)
                  : null
              }
              onChange={onVoucherStartDateTimeChange}
              format={getDatePickerDisplayFormat()}
              disabled={isStatusInActive ? true : isAttached}
              ToolbarComponent={LocalizedDatePickerToolbar}
              okLabel={formatMessage({ id: 'date.picker.ok' })}
              cancelLabel={formatMessage({ id: 'date.picker.cancel' })}
              clearLabel={formatMessage({ id: 'date.picker.clear' })}
            />
          </Grid>
          <Grid item xs={12} md={6} className="mb-10">
            <DatePicker
              className="w-full"
              required
              label={formatMessage({
                id: 'createNotification.dialog.voucher.endDate',
              })}
              inputProps={{
                'data-testid': 'endDate',
              }}
              inputVariant="outlined"
              value={
                state[endDateTimeKey]
                  ? moment(state[endDateTimeKey], API_DATE_FORMATTED)
                  : null
              }
              onChange={onEventEndDateTimeChange}
              {...getValidMinEndDate()}
              minDate={state[startDateTimeKey] || minDate}
              maxDate={maxDate}
              format={getDatePickerDisplayFormat()}
              disabled={
                isStatusInActive
                  ? true
                  : isAttached &&
                    isPastEndDateVoucher(state[endDateTimeKey]) &&
                    isPastEndDateVoucher(initialModel.voucher.endDateTime)
              }
              ToolbarComponent={LocalizedDatePickerToolbar}
              okLabel={formatMessage({ id: 'date.picker.ok' })}
              cancelLabel={formatMessage({ id: 'date.picker.cancel' })}
              clearLabel={formatMessage({ id: 'date.picker.clear' })}
            />
          </Grid>
        </Grid>
      </LocalizedDatePickerProvider>
    </>
  )
}

export default VoucherStartEndTime
